import React from "react";
import type { FC, PropsWithChildren} from "react";
import {
  InputsSection,
  ModalButtons,
  ModalForm,
  Modal,
} from "../../components/Modal";
import ModalHeading from "../../components/Modal/ModalHeading";
import ChatFile from "../../components/Modal/ChatFileCard";
import {  } from "../../hooks/rtmTemplate";
import {  IRtmTemplateRes } from "../../hooks/rtmTemplate/index.type";


export type IAddTemplateModalState = PropsWithChildren<{
  status: boolean;
  // data?: IClinic;
}>;
export interface ISelectedTemplate {
    id:string|undefined,
    message:string
}
export type AddTemplateModalProps = PropsWithChildren<{
  loading: boolean;
  addTemplateModal: IAddTemplateModalState;
  onCloseModal?: () => void;
  handleAddTemplate?: (template: ISelectedTemplate) => void;
  templateData:IRtmTemplateRes | undefined
}>;


const AddTemplateModal: FC<AddTemplateModalProps> = (props) => {
  const [selectedTemplate, setSelectedTemplate] = React.useState<ISelectedTemplate | null>(
    null
  );
  const handleTemplateSelect = (selectedTemplate:ISelectedTemplate) => {
    setSelectedTemplate(selectedTemplate);
  };

  const handleInsert = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (selectedTemplate) {
      props.handleAddTemplate?.(selectedTemplate);
      props.onCloseModal?.();
    }
  };



  return (
    <Modal  style={{maxWidth:"50%",maxHeight:"85%",padding:'0'}} show={props.addTemplateModal.status}>
      <ModalHeading heading="Select Template" />

      <ModalForm onSubmit={handleInsert}
        style={{
          paddingRight: "1rem",
        }}>
        <InputsSection style={{ display: "flex", flexDirection: "column",maxHeight: "300px",   
          overflowY: "auto"}}>
          {props.templateData?.data.data?.map((template) => (
            <ChatFile
              key={template._id}
              location="template"
              type="text"
              templateData={template}
              isSelected={selectedTemplate?.id === template._id}
              onSelect={() => handleTemplateSelect({id:template._id,message:template.name})}
            />
          ))}
        </InputsSection>
        <ModalButtons
          submitButtonLabel="Select"
          cancelButtonLabel="Cancel"
          onCancel={props.onCloseModal}
        />
      </ModalForm>
    </Modal>
  );
};

export default AddTemplateModal;
